import React from 'react';
import PrivacyPolicy from '../components/privacyPolicy';

function privacyPolicy() {
    return <PrivacyPolicy />;
}

export default privacyPolicy();
